<template>
    <v-container class="past-event-detail p-0" v-if="event" fluid>
        <HkiaraceBannerFrame :src="require('../../../assets/memorable-moments.png')"
                             :label="$t('past_event.title')">
            <div class="event-details">
                <HkiaraceCardDisplayFrame :is-default-order-sm="true"
                                          :image-src="host + 'static/' + (event.memorable_moment_cover_id? event.memorable_moment_cover_id : event.banner)">
                    <template slot="sub-title">
                        {{event.category.name}}
                    </template>
                    <template slot="title">
                        <span v-html="event.name"></span>
                    </template>
                    <template slot="content">
                        <div class="event-detail-content">
                            <div class="content-row">
                                <div class="content-field">
                                    <div class="field-label">
                                        {{$t('event.date')}}
                                    </div>
                                    <div class="field-content" v-html="eventDateLabel(event)">
                                    </div>
                                </div>
                                <div class="content-field" v-if="event.signup_mode === -1 || event.signup_mode === 1">
                                    <div class="field-label">
                                        {{$t('event.time')}}
                                    </div>
                                    <div class="field-content">
                                        {{eventTimeLabel(event)}}
                                    </div>
                                </div>
                            </div>
                            <div class="content-row">
                                <div class="content-field">
                                    <div class="field-label">
                                        {{$t('event.location')}}
                                    </div>
                                    <div class="field-content">
                                        {{event.location}}
                                    </div>
                                </div>
                                <div class="content-field" v-if="event.quota !== -1">
                                    <div class="field-label">
                                        {{$t('event.quota')}}
                                    </div>
                                    <div class="field-content">
                                        {{$t('event.quota_template', {quota: event.quota})}}
                                    </div>
                                </div>
                            </div>
                            <div class="content-row">
                                <div class="content-field">
                                    <div class="field-label">
                                        {{$t('event.fee')}}
                                    </div>
                                    <div class="field-content" v-html="eventFeeLabel(event)">
                                    </div>
                                </div>
                            </div>
<!--                            <div class="content-row">-->
<!--                                <div class="content-field">-->
<!--                                    <div class="field-label">-->
<!--                                        {{$t('event.languages')}}-->
<!--                                    </div>-->
<!--                                    <div class="field-content">-->
<!--                                        {{eventLanguageLabel(event)}}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                            <v-row>
                                <v-col class="event-detail-buttons">
                                    <v-btn color="grey" dark rounded
                                           v-if="event.poster"
                                           @click="downloadFile(event.poster)">
                                        <v-icon>mdi-download</v-icon>
                                        {{$t('event.download_poster')}}
                                    </v-btn>
                                    <v-btn color="grey" dark rounded
                                           v-if="event.attachment_id"
                                           @click="downloadFile(event.attachment_id)">
                                        <v-icon>mdi-download</v-icon>
                                        {{$t('event.download_attachment')}}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-row>
                                    <v-col cols="6" lg="3" md="4"
                                           v-for="m in event.memorable_moments" :key="m.id"
                                           class="memorable-moment-cell">
                                        <div :style="getMemorableMomentStyle(m)"
                                             class="memorable-moment-cell-img animation-ease hover-scale"></div>
                                    </v-col>
                                </v-row>
                            </v-row>
                        </div>
                    </template>
                </HkiaraceCardDisplayFrame>
            </div>
        </HkiaraceBannerFrame>
        <!--        <b-row>-->
        <!--            <b-col>-->
        <!--                <b-carousel indicators-->
        <!--                            :controls="event.memorable_moments.length > 1">-->
        <!--                    <b-carousel-slide v-for="moment in event.memorable_moments"-->
        <!--                                      :img-src="'/api/static/' + moment.photo">-->
        <!--                        <template slot="img">-->
        <!--                            <div class="moment-slide" :style="getMomentStyle(moment)">-->

        <!--                            </div>-->
        <!--                        </template>-->
        <!--                    </b-carousel-slide>-->
        <!--                </b-carousel>-->
        <!--            </b-col>-->
        <!--        </b-row>-->
        <!--        <b-row class="past-event-body">-->
        <!--            <b-col>-->
        <!--                <EventDetail :event="event" hide-past-moment-btn></EventDetail>-->
        <!--            </b-col>-->
        <!--        </b-row>-->
    </v-container>
</template>

<script>
    import {HOST} from '../../../main'
    import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
    import HkiaraceCardDisplayFrame from "../../../components/HkiaraceCardDisplayFrame";
    import {DateTime} from "luxon";

    export default {
        name: 'PastEventDetail',
        components: {HkiaraceCardDisplayFrame, HkiaraceBannerFrame},
        data() {
            return {
                eventId: this.$route.params.eventId,
                event: null,
                host: HOST,
            };
        },
        mounted() {
            this.getEvent();
        },
        methods: {
            getEvent() {
                this.$callAPI('hkiarace/event/past/', {id: this.eventId}, function (response) {
                    this.event = response.body.event;
                });
            },
            eventDateLabel(event) {
                let v = this;
                if (event.signup_mode === -1 || event.signup_mode === 1) {
                    return DateTime.fromISO(event.date).toFormat('yyyy-MM-dd');
                } else if (event.signup_mode === 2) {
                    return event.sessions.map((session) => {
                        let start = DateTime.fromISO(session.start);
                        let end = DateTime.fromISO(session.end);


                        let datetime_label = session.name + ": " + start.toFormat('d/M/y, T') + " - " + end.toFormat('T');
                        let quota_label = session.quota === -1 ? "" : " (" + v.$t('event.quota_template', {quota: session.quota}) + ")";

                        return datetime_label + quota_label;
                    }).join('<br>');
                } else if (event.signup_mode === 3) {
                    return event.series.map((series) => {
                        return series.name + (series.quota === -1 ? "" : " (" + v.$t('event.quota_template', {quota: series.quota}) + ")");
                    }).join("<br>");
                }

                return "";
            },
            eventTimeLabel(event) {
                if (event.signup_mode === -1 || event.signup_mode === 1) {
                    return DateTime.fromISO(event.from_time).toFormat('HH:mm') + ' - ' + DateTime.fromISO(event.to_time).toFormat('HH:mm');
                }
                return '';
            },
            eventFeeTiers(event) {
                return JSON.parse(event.fee_tiers || '[]');
            },
            eventFeeLabel(event) {
                let feeTiers = this.eventFeeTiers(event);

                if (feeTiers.length === 0) {
                    return this.$t('event.free');
                } else if (feeTiers.length === 1 && !feeTiers[0].name) {
                    return 'HKD ' + feeTiers[0].fee;
                } else {
                    return feeTiers.map((t) => {
                        return (t.name ? t.name + ": " : "") + ("HKD " + t.fee);
                    }).join('<br>');
                }
            },
            isEventMultiFeeTiers(event) {
                let feeTiers = this.eventFeeTiers(event);

                return feeTiers.length !== 0 && feeTiers[0].name;
            },
            eventLanguageLabel(event) {
                let v = this;
                return JSON.parse(event.languages).map(function (l) {
                    return v.$t('languages.' + l);
                }).join(", ")
            },
            downloadFile(file_id) {
                window.open('/api/static/' + file_id, '_blank');
            },
            getMemorableMomentStyle(m) {
                return {
                    'background-image': `url("${HOST}static/` + m.photo + '")',
                }
            },
        },
    }
</script>


<style lang="less">
    @import "../../../styles/client/main";

    .past-event-detail {
        .event-details {
            background-color: white;

            .event-detail-content {

                .content-row {
                    display: flex;
                    flex-wrap: wrap;

                    .title-font();

                    .content-field {
                        width: 50%;
                        flex-grow: 1;

                        padding: 10px 0;

                        .field-label {
                            color: #8E765B;
                        }

                        .field-content {

                        }


                        @media only screen and (max-width: 1200px) {
                            width: 100%;
                        }
                    }
                }

                .v-label {
                    color: #8E765B;
                    .title-font()
                }

                .v-text-field > .v-input__control > .v-input__slot:before {
                    display: none;
                }

                .v-text-field > .v-input__control > .v-input__slot:after {
                    display: none;
                }
            }

            .event-detail-buttons {
                .v-btn {
                    margin-right: 1rem;
                    margin-top: .5rem;
                }
            }
        }

        .memorable-moment-cell {
            .memorable-moment-cell-img {
                background-color: white;
                width: 100%;
                padding-top: 100%;
                background-size: 80%;
                background-position: center;
                background-repeat: no-repeat;
            }
        }
    }
</style>